import * as React from 'react';
import { JSX } from 'react/jsx-runtime';
const CalenderIconDark = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 2.66927V1.33594V2.66927ZM10 2.66927V4.0026V2.66927ZM10 2.66927H7H10ZM2 6.66927V12.6693C2 13.4057 2.59695 14.0026 3.33333 14.0026H12.6667C13.4031 14.0026 14 13.4057 14 12.6693V6.66927H2Z"
      stroke="#EEF7FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 6.66406V3.9974C2 3.26102 2.59695 2.66406 3.33333 2.66406H4.66667"
      stroke="#EEF7FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.66699 1.33594V4.0026"
      stroke="#EEF7FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.9997 6.66406V3.9974C13.9997 3.26102 13.4027 2.66406 12.6663 2.66406H12.333"
      stroke="#EEF7FF"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default CalenderIconDark;
